var bookshelf = require("../index-extended");
require("./Meeting");
require("./Mandate");

module.exports = bookshelf.model("MeetingCorrespondenceVote", {
  entityName: "MeetingCorrespondenceVote",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "meeting_correspondence_vote",
  meeting() {
    return this.belongsTo("Meeting");
  },

  mandate() {
    return this.belongsTo("Mandate");
  },

  format(attrs) {
    delete attrs["$id"];
    delete attrs["meeting"];
    delete attrs["mandate"];
    return attrs;
  },
});
